import { Reducer } from "redux";
import { AppRootState } from "./root-reducer";
import { createSelector } from "reselect";
import { ChatCommonState, ChatCommonStateInit } from "../types/common-types";
import { ChatCommonActions } from "../actions/chat-common-actions";

export const chatCommonReducer: Reducer<ChatCommonState> = (state = ChatCommonStateInit, action) => {
    switch (action.type) {
        case ChatCommonActions.LAST_RESPONSE_TIME:
            sessionStorage.setItem("lastRequestTime", new Date().toString());
            return {
                ...state,
                lastResponseTime: new Date()
            }
        case ChatCommonActions.SET_WELCOME_MESSAGE_RESULT:
            // console.log("44444444",action.payload);
            return{
                ...state,
                welcomeMsg: action.payload
            }
        default:
            return state
    }
}

const lastResponseTime = (state: AppRootState) => state.chatCommon.lastResponseTime;
export const getLastResponseTime = createSelector([lastResponseTime], (data) => data);

const chatCommon = (state: AppRootState) => state.chatCommon.welcomeMsg;
export const getChatCommon = createSelector([chatCommon], (data) => data);

const securityAlert = (state: AppRootState) => state.chatCommon.welcomeMsg.securityAlert;
export const getSecurityAlert = createSelector([securityAlert], (data) => data);

const scheduleSecurityAlert = (state: AppRootState) => state.chatCommon.welcomeMsg.scheduleSecurityAlert;
export const getScheduleSecurityAlert = createSelector([scheduleSecurityAlert], (data) => data)

const securityAlertStartTime = (state: AppRootState) => state.chatCommon.welcomeMsg.securityAlertStartTime;
export const getSecurityAlertStartTime = createSelector([securityAlertStartTime], (data) => data)

const securityAlertEndTime = (state: AppRootState) => state.chatCommon.welcomeMsg.securityAlertEndTime;
export const getSecurityAlertEndTime = createSelector([securityAlertEndTime], (data) => data)